import { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavLink } from 'reactstrap';
import MenuItem from '../MenuItem/MenuItem';
import { MultiLevelDropdown2Wrapper } from './MultiLevelDropdown2.styled';

const menuData = [
   { label: "Java Programs", href: "/java-programs"},
   { label: "Stream API Programs", href: "/stream-api-programs"},
   { label: "Dynamic Programming Programs", href: "/dp-programs"}
];


const MultiLevelDropdown = () => {

   const [dropdownOpen, setDropdownOpen] = useState(false);

   return (
      <MultiLevelDropdown2Wrapper>
         <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
            <div className="multi-dropdown" style={{ display: 'flex', justifyContent: "flex-end" }}>
               <NavLink href="/interview-programs"  style={{ paddingRight: 0 }}>Interview Programs</NavLink>
               <DropdownToggle nav caret style={{ paddingLeft: '0rem', fontSize: 'x-large', paddingTop: '0.2rem' }}></DropdownToggle>
            </div>
            <DropdownMenu>
               {menuData.map((item, i) => (
                  <>
                     <MenuItem key={i} {...item} />
                     {menuData.length !== i+1 && <DropdownItem divider />}
                  </>
               ))}
            </DropdownMenu>
         </Dropdown>
      </MultiLevelDropdown2Wrapper>
   );
}

export default MultiLevelDropdown;